import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
//import { AuthenticationService } from "../../../app.service";
import { ApiService } from "../../shared/Services/api.service";
import { AuthService } from "../../shared/Services/auth.service";
import { environment } from "src/environments/environment";

@Injectable()
export class CoreService {
  private coreApiPath: string;

  constructor(
    //private mainAPI: AuthenticationService,
    private http: HttpClient,
    //private authenticationService: AuthenticationService,
    public apiService: ApiService,
    public authService: AuthService
  ) {
    this.coreApiPath = environment.coreapipath;
  }

  loginAPI(data: any): Observable<any> {
    const localurl = `/ISDPToken`;
    return this.apiService.post(localurl, data);
  }

  SingleLoginAPI(data: any): Observable<any> {
    const localurl = `/ISDPToken/Login`;
    return this.apiService.post(localurl, data);
  }

  forgetPassword(formData: any) {
    const localurl = `SignUp/ForgetPass`;
    const data = { emailId: formData };
    return this.apiService.post(localurl, data);
  }

  VforgetPassword(formData: any) {
    const localurl = `VSignUp/ForgetPass`;
    const data = { emailId: formData };
    return this.apiService.post(localurl, data);
  }

  resetPassword(formData: any) {
    const localurl = `VSignUp/ResetPass`;
    return this.apiService.post(localurl, formData);
  }

  changePassword(formData: any) {
    const localurl = `SignUp/ChangePass`;
    return this.apiService.post(localurl, formData);
  }

  supplierIniData(id: any) {
    const localurl = `SignUp`;
    return this.apiService.get(localurl);
  }

  loadAllState = (countryId: number) => {
    const localurl = `/State/` + countryId;
    return this.apiService.get(localurl,undefined, false);
  }

  addSupplier(data: any) {
    let url = `/SignUp/Supplier`
    return this.apiService.post(url, data);
  }

  VerifyLink = (tdslId: any) => {
    const localurl = `dsl/VerifyLink/` + tdslId;
    return this.apiService.get(localurl);
  }
}
